// utils/formatters.ts

export const formatCurrency = (value: number, currency: string = 'USD') =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(value);

export const formatNumber = (value: number) =>
  new Intl.NumberFormat("en-US").format(value);

export const formatPercentage = (value: number, decimals: number = 1) =>
  `${value.toFixed(decimals)}%`;

export const formatDecimal = (value: number, decimals: number = 2) =>
  value.toFixed(decimals);